import { DetailsList, getTheme, Icon, Link } from "@fluentui/react";

import { TermStepEnum } from "@/modules/Terms/enums/termStep.enum";
import { TermStepTranslatorEnum } from "@/modules/Terms/enums/termStepTranslator.enum";
import { ITerm } from "@/modules/Terms/interfaces/ITerm.interface";
import { termTypeRoutes } from "@/modules/Terms/utils/handleTermRouteRedirection";

interface TableProp {
  terms: ITerm[];
}

const theme = getTheme();

const statusIcon = {
  [TermStepEnum.DONE]: {
    name: "CompletedSolid",
    color: theme.semanticColors.successIcon
  },
  [TermStepEnum.CANCELED]: {
    name: "StatusErrorFull",
    color: theme.semanticColors.severeWarningIcon
  },
  [TermStepEnum.REJECTED]: {
    name: "StatusErrorFull",
    color: theme.semanticColors.errorIcon
  },
  default: { name: "Clock", color: theme.palette.themeDark }
};

const columns = [
  {
    key: "status",
    name: "Status",
    fieldName: "status",
    minWidth: 30,
    maxWidth: 50,
    className: "ms-fontSize-16",
    onRender: (item: ITerm) => {
      const currentStep = item?.currentStep?.internalName;

      const icon = statusIcon[currentStep]
        ? statusIcon[currentStep]
        : statusIcon.default;

      return (
        <Icon
          iconName={icon.name}
          style={{
            color: icon.color,
            fontSize: 20
          }}
        />
      );
    }
  },
  {
    key: "id",
    name: "Documento",
    fieldName: "id",
    data: "number",
    minWidth: 50,
    maxWidth: 100,
    className: "ms-fontSize-16",
    onRender: (item: ITerm) => {
      const termType = item.termType;
      const route = termTypeRoutes[termType];

      return <Link href={`${route}/${item?.id}`}>{item?.id}</Link>;
    }
  },
  {
    key: "currentStepName",
    name: "Etapa Atual",
    fieldName: "currentStepName",
    minWidth: 100,
    className: "ms-fontSize-16",
    onRender: (item: ITerm) => {
      return (
        <span>{TermStepTranslatorEnum[item?.currentStep?.internalName]}</span>
      );
    }
  }
];

function ComplementaryDocumentsTable({ terms }: TableProp): JSX.Element {
  return (
    <div style={{ height: "100%" }}>
      <DetailsList
        selectionMode={0}
        items={terms?.map(term => ({
          id: term?.id,
          currentStep: term?.currentStep,
          termType: term?.termType
        }))}
        columns={columns}
        setKey="complementaryDocumentsTable"
        styles={{
          headerWrapper: {
            selectors: { "& .ms-DetailsHeader": { paddingTop: 0 } }
          },
          focusZone: { cursor: "pointer" }
        }}
        onActiveItemChanged={(item: ITerm) => {
          if (item?.id) {
            const termType = item.termType;
            const route = termTypeRoutes[termType];

            window.location.href = `${route}/${item.id}`;
          }
        }}
      />
    </div>
  );
}

export default ComplementaryDocumentsTable;
